import Toast from "./ToastNotification";
import toastStyle from "../../styles/toaster.module.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { ToastNotification } from "../../types/errors";
import { removeNotification } from "../../store/toastNotifications";
import labels from "../../utils/labels";

const ToastWrapper = () => {
  const dispatch = useAppDispatch();
  const { notifications } = useAppSelector((state) => state.toastNotifications);

  return (
    <>
      {notifications && (
        <div className={toastStyle.toastWrapper}>
          {notifications.map((notification, index) => {
            const variant = notification.variant || "error";
            const title =
              notification.title ??
              (variant === "success"
                ? labels.toastSuccessTitle
                : variant === "info"
                  ? labels.toastInfoTitle
                  : labels.toastErrorTitle);

            return (
              <Toast
                key={`${notification.type}-${index}`}
                title={title}
                variant={variant}
                removeError={() => dispatch(removeNotification(index))}
              >
                {notification.message}
              </Toast>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ToastWrapper;
